//data.js
const productsArray = [
    {
        id: "price_1So6NHCYSh81T3HXajIgsIms",
        img:"/images/products/cash-box01.png",
        images: [
            "/images/products/cash-box01.png",
            "/images/products/cash-box02.jpg"
        ],
        title: "Cash Box - Fully Assembled and Programmed",
        price: 995.00,
        description: "Complete Cash Box system ready to use out of the box. Fully assembled with all components installed and pre-programmed software. Includes Bluetooth keyboard for seamless connectivity and easy operation.",
        details: "This premium package includes a fully assembled Cash Box with all internal components properly installed and configured. The system comes pre-programmed with the latest software, eliminating the need for technical setup. The included Bluetooth keyboard allows for wireless connectivity and convenient data entry. Perfect for businesses looking for a plug-and-play solution."
    },
    {
        id: "price_1So6KTCYSh81T3HXSFKcxSW2",
        img:"/images/products/wood-frame.jpg",
        images: [
            "/images/products/wood-frame-01.jpg",
            "/images/products/wood-frame-02.jpg",
            "/images/products/wood-frame-03.jpg",
            "/images/products/wood-frame.jpg"
        ],
        title: "Wood Frame",
        price: 50.00,
        description: "High-quality wooden frame for Cash Box with pre-cut knockout sections. Perfect for DIY enthusiasts who want to build their own custom Cash Box system.",
        details: "This wooden frame kit includes all the necessary wooden components with precision-cut knockout sections for easy component installation. Made from durable, high-quality wood, this frame is customized around the touchscreen (available through Amazon). Ideal for those who enjoy building and customizing their own systems or need a replacement frame for an existing setup."
    },
    {
        id: "price_1So6IECYSh81T3HX2NHD1yL1",
        img:"/images/products/corner-braket-hardware.jpg",
        images: [
            "/images/products/corner-braket-hardware.jpg",
            "/images/products/corner-brackets.jpg"
        ],
        title: "Plastic Corner Brackets & Bolts",
        price: 25.00,
        description: "Essential hardware kit for Cash Box assembly. Includes durable plastic corner brackets bolts for secure frame construction.",
        details: "This hardware kit contains high-quality plastic corner brackets designed specifically for Cash Box frame assembly. The kit includes all necessary 10x 6-32 machine screws and nyloc nuts for secure fastening. These brackets provide excellent structural support and are essential for building a sturdy Cash Box frame. It also contains the plastic knock-out to cover the hole used to connect USB accessories to the Raspberry Pi."
    },
    {
        id: "price_1So6ErCYSh81T3HXqzEYNyqc",
        img:"/images/products/rpi-screen-mount.jpg",
        images: [
            "/images/products/rpi-screen-mount.jpg",
            "/images/products/screen-mounting-hardware.jpg"
        ],
        title: "Mounting Hardware for RPi and Screen",
        price: 25.00,
        description: "Essential hardware kit for Cash Box assembly of the screen to the frame and Raspberry Pi.",
        details: "This hardware kit contains a laser-cut board to connect the Raspberry Pi to the touchscreen. This board is needed because the RPi has an NVMe SSD mounted to the underside of it. 8x m3 machine screws are provided to connect the screen, board, and RPi. 4x machine screws and nyloc nuts are provided to connect the screen to the wood frame. 4x 6-32 acorn nuts are provided to secure the wood frame to the box."
    },
    {
        id: "price_1So6CaCYSh81T3HXSWwAb0HU",
        img:"/images/products/cash-box01.png",
        images: [
            "/images/products/cash-box01.png",
            "/images/products/cash-box02.jpg"
        ],
        title: "Cash Box - Fully Assembled (Not Programmed)",
        price: 700.00,
        description: "Cash Box system fully assembled with all hardware components installed. But only Ubuntu 24.04 LTS operating system installed, with no Cash Stack software.",
        details: "This Cash Box comes fully assembled with all physical components properly installed, including the frame, internal electronics, and all necessary hardware. However, the software is not pre-programmed, giving you the flexibility to configure it according to your specific business needs. Perfect for users who like the form-factor and hardware, but are not interested in the Cash Stack software."
    },
    {
        id: "price_1SrNZ4CYSh81T3HXfsw6coUz",
        img:"/images/products/software-updates.jpg",
        images: [
            "/images/products/software-updates.jpg"
        ],
        title: "Software Updates",
        price: 200.00,
        description: "The BCH full node requires an update once per year. The other Cash Stack software also benefit from regular updates. This support package enables remote administration for software updates to your box. This service saves you the hassle of keeping your Cash Box software up to date.",
        details: "If you purchase a fully-assembled Cash Box, this support package enables remote administration for software updates to your box. This service saves you the hassle of keeping your Cash Box software up to date."
    },
    // {
    //     id: "price_1So692CYSh81T3HX0RogLL2F",
    //     img:"/images/products/blue-widget.jpeg",
    //     images: [
    //         "/images/products/blue-widget.jpeg",
    //     ],
    //     title: "Blue Widget",
    //     price: 1.00,
    //     description: "A test product.",
    //     details: "This is not a real product. It's used for testing the payment integration."
    // },
];
//helper function
function getProductData(id) {
    let productData = productsArray.find(product => product.id === id);

    if (productData === undefined) {
        console.log("Product data does not exist for ID: " + id);
        return undefined;
    }

    return productData;
}

export { productsArray, getProductData };